require("@makeleaps/ui/dist/export.css");
import { initializeI18n, initializeSentry, State } from "@makeleaps/ui";
import * as Sentry from "@sentry/browser";
import { render } from "react-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import nestedRoutes from "./router";
import { ReactProperties } from "./types";
const router = createBrowserRouter([
  {
    path: "/",
    // Error displayed when routes are not correctly configured
    // If encountering this error, check makeleaps_ui/src/router.tsx to ensure you are
    // importing the correct value and that a pageRoute() exists
    errorElement: <div>Error on page!</div>,
    children: nestedRoutes,
  },
]);

function initializeUI() {
  const { styleSheetURL, reactdata } = (document as unknown) as {
    styleSheetURL: string;
    reactdata: ReactProperties;
  };
  const shadow = document.getElementById("react-root");
  if (!shadow) throw new Error("shadowDom not found!");
  shadow.attachShadow({ mode: "open" });

  const style = document.createElement("style");
  style.innerHTML = `
     html {
       font-size: 100%;
     }
   `;
  shadow.shadowRoot?.appendChild(style);

  const linkElem = document.createElement("link");
  linkElem.setAttribute("rel", "stylesheet");
  linkElem.setAttribute("href", styleSheetURL);
  // Wait for CSS to finish loading to avoid flickering or incorrectly-sized SVGs
  linkElem.onload = () => {
    const container = document.createElement("div");

    shadow.shadowRoot?.appendChild(container);

    initializeI18n();
    initializeSentry(Sentry);

    render(
      <State
        data={reactdata.data}
        appPermissions={reactdata.app_permissions}
        messages={reactdata.messages}
        flags={reactdata.flags}
      >
        <RouterProvider router={router} />
      </State>,
      container
    );
  };
  shadow.shadowRoot?.appendChild(linkElem);
}

initializeUI();
